import ResourceService from "./resource.service";

class VehicleTypeService extends ResourceService {
  static get resource() {
    return "vehicle-type";
  }
}

export default VehicleTypeService;